"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _buffer = require("buffer");

var _trackerUtil = require("./trackerUtil");

var _get2 = _interopRequireDefault(require("lodash/get"));

/* eslint-disable camelcase */
// const PUBSUB_ENDPOINT = {
//   production:
//     "https://pubsub.googleapis.com/v1/projects/supersoccer-173813/topics/ds-feeder-guardian:publish",
//   staging:
//     "https://pubsub.googleapis.com/v1/projects/staging-199507/topics/ds-feeder-guardian:publish"
// };
// const TOKENENDPOINT = {
//   production:
//     "https://supersoccer.tv/api/v2/videos/_/pubsub",
//   staging:
//     "https://stag.supersoccer.tv/api/v2/videos/_/pubsub"
// };
var Tracker = {};
/*** Tracker for Web - Start ***/

Tracker.sessionId = function () {
  var sessionId = (0, _get2["default"])(document, 'cookie', '').trim().split(';').filter(function (item) {
    return item.indexOf('__sessionId=') >= 0;
  });
  var sessionIdVal = '';

  if (sessionId[0]) {
    sessionIdVal = sessionId[0].split('=')[1];
  }

  if (sessionId && sessionId.length > 0 && sessionIdVal) {
    sessionId = sessionId[0].split('=')[1];
    document.cookie = "__sessionId=".concat(sessionId, "; max-age=").concat(30 * 60, "; path=/;");
  } else {
    sessionId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    document.cookie = "__sessionId=".concat(sessionId, "; max-age=").concat(30 * 60, "; path=/;");
  }

  return sessionId;
};

Tracker.clientId = function () {
  var clientId = (0, _get2["default"])(document, 'cookie', '').trim().split(';').filter(function (item) {
    return item.indexOf('__clientId=') >= 0;
  });
  var clientIdVal = '';

  if (clientId[0]) {
    clientIdVal = clientId[0].split('=')[1];
  }

  if (clientId && clientId.length > 0 && clientIdVal) {
    clientId = clientId[0].split('=')[1];
    document.cookie = "__clientId=".concat(clientId, "; max-age=").concat(60 * 60 * 24 * 365 * 2, "; path=/;");
  } else {
    clientId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    document.cookie = "__clientId=".concat(clientId, "; max-age=").concat(60 * 60 * 24 * 365 * 2, "; path=/;");
  }

  return clientId;
};

Tracker.getLangLat = function () {
  var latitude = '',
      longitude = '';
  var options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  };
  var location = (0, _get2["default"])(document, 'cookie', '').trim().split(';').filter(function (item) {
    return item.indexOf('__loc=') >= 0;
  });

  if (location && location.length > 0) {
    location = location[0].split('=')[1];
  } else {
    try {
      location = localStorage.getItem('user-location');
    } catch (err) {}

    if (window.navigator.geolocation) {
      // console.log("MASUK SINI?")
      window.navigator.geolocation.getCurrentPosition(function (position) {
        latitude = position.coords.latitude;
        longitude = position.coords.longitude;
        location = "".concat(latitude, ",").concat(longitude); // console.log(latitude);
        // console.log(longitude);

        document.cookie = "__loc=".concat(location, "; max-age=").concat(60 * 60, "; path=/;");

        try {
          localStorage.setItem('user-location', location);
        } catch (err) {}
      }, function () {}, options);
    }
  } // console.log("location", location)


  return location;
};

Tracker.getOrCreateToken = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(tokenEndPoint, cookieName) {
    var token;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // try to get pubsub token from cookie first
            token = (0, _get2["default"])(document, 'cookie').trim().split(';').filter(function (item) {
              return item.indexOf("".concat(cookieName, "=")) >= 0;
            });

            if (!(token.length > 0)) {
              _context.next = 5;
              break;
            }

            // if theres token return it
            token = token[0].split('=')[1];
            _context.next = 8;
            break;

          case 5:
            _context.next = 7;
            return _axios["default"].post(tokenEndPoint).then(function (response) {
              return response.data;
            }).then(function (data) {
              token = data.data.accessToken;
              document.cookie = "".concat(cookieName, "=").concat(token, "; max-age=").concat(60 * 60, "; path=/;");
              return token;
            })["catch"](function () {
              return null;
            });

          case 7:
            token = _context.sent;

          case 8:
            return _context.abrupt("return", token);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

Tracker.sendPubSub = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(token, payload, pubsubUrl) {
    var postToDS, reqBody, options;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // const keys = Object.keys(payload.data);
            // let url = pubsub_url;

            /* pubsub_url is optional, if not specified then use the default one 
            pubsub_url is only used in case other project need different pubsub url
            */
            // if(!pubsub_url) {
            //   url = env ? pubsub[env] : PUBSUB_ENDPOINT;
            // }
            // let url = PUBSUB_ENDPOINT[env]
            // const adjustedPayload = payload
            // Delete/unsend all missing/null values in payload.data
            // keys.forEach(key => {
            //   if (
            //     !payload.data[key] ||
            //     payload.data[key] === null ||
            //     payload.data[key].length < 1 ||
            //     payload.data[key][0] === null
            //   ) {
            //     delete adjustedPayload.data[key]
            //   }
            // })
            postToDS = _buffer.Buffer.from(JSON.stringify(payload)).toString("base64");
            reqBody = {
              messages: [{
                data: postToDS
              }]
            };
            options = {
              method: "POST",
              headers: {
                Authorization: "Bearer ".concat(token),
                "Content-Type": "application/json"
              },
              data: JSON.stringify(reqBody),
              url: pubsubUrl
            };
            return _context2.abrupt("return", (0, _axios["default"])(options)["catch"](function () {}));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

Tracker.getIntervalBeats = function () {
  return 60;
};

function addListenerMulti(el, s, fn) {
  s.split(' ').forEach(function (e) {
    return el.addEventListener(e, fn, false);
  });
}

Tracker.trackEvent = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref3) {
    var data, pubsubConfig, pubsubUrl, tokenEndPoint, cookieName, timer, payload, token;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            data = _ref3.data, pubsubConfig = _ref3.pubsubConfig;
            pubsubUrl = 'http://pubsub.com';
            tokenEndPoint = '';
            cookieName = '';

            if (pubsubConfig) {
              pubsubUrl = pubsubConfig.url;
              tokenEndPoint = pubsubConfig.token_url;
              cookieName = pubsubConfig.cookie;
            }

            if (data.event === 'event_video_plays') {
              data.sessionId = Tracker.sessionId();
            } else {
              timer = null;
              data.sessionId = Tracker.sessionId();
              addListenerMulti(data.document, 'click mousemove touchmove mouseup mousedown keydown keypress keyup submit change mouseenter scroll resize dblclick', function (e) {
                if (timer) clearTimeout(timer);
                timer = setTimeout(function (t) {
                  data.sessionId = Tracker.sessionId();
                }, 60000); //60000
              });
            }

            data.clientId = Tracker.clientId();
            data.geolocation = Tracker.getLangLat();
            payload = (0, _trackerUtil.handleTracker)(data);
            _context3.next = 11;
            return Tracker.getOrCreateToken(tokenEndPoint, cookieName);

          case 11:
            token = _context3.sent;
            return _context3.abrupt("return", Tracker.sendPubSub(token, payload, pubsubUrl));

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x6) {
    return _ref4.apply(this, arguments);
  };
}();
/*** Tracker for Web - End ***/


module.exports = Tracker;